<ng-container *ngIf="{ costAccountingState: costAccountingState$ | async, sharedDataState: sharedDataState$ | async } as states">

    <div class="cost-accounting-container mat-elevation-z8">
        <div class="table-header" [formGroup]="filterFormGroup">


            <mat-form-field  style="width: 30%" subscriptSizing="dynamic">
                <mat-label>{{ "app.page.cost-accounting.type-filter.label" | translate }}</mat-label>
                <mat-select formControlName="typeFilter">
                    <mat-option *ngFor="let type of states.sharedDataState.costAccountingTypeLookup | keyvalue" [value]="type.value.id">
                        {{ type.value.name }}
                    </mat-option>
                </mat-select>
                <button mat-icon-button matSuffix (click)="filterFormGroup.controls.typeFilter.setValue(null); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field style="width: 40%" subscriptSizing="dynamic">
                <mat-label>{{ "app.page.cost-accounting.date-filter.label" | translate }}</mat-label>
                <mat-date-range-input [formGroup]="filterFormGroup.controls.dateFilter" [rangePicker]="picker">
                    <input matStartDate formControlName="start">
                    <input matEndDate formControlName="end">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
                <button mat-icon-button matSuffix (click)="filterFormGroup.controls.dateFilter.reset(); $event.stopPropagation()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value"
                        (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <button mat-mini-fab
                    (click)="openDialog()"
                    color="primary"
                    matTooltip="{{ 'app.page.cost-accounting.actions.add.label' | translate }}">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="(states.costAccountingState.isLoading || states.sharedDataState.isLoading) ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.cost-accounting.name.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element"> {{ element.name }}</td>
                </ng-container>

                <ng-container matColumnDef="costAccountingType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.cost-accounting.costAccountingType.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{element.costAccountingType.name}}</td>
                </ng-container>

                <ng-container matColumnDef="from">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.cost-accounting.from.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.dateRange.from | date: 'dd.MM.yyyy' }}</td>
                </ng-container>


                <ng-container matColumnDef="to">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.cost-accounting.to.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">{{ element.dateRange.to | date: 'dd.MM.yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="progress">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.model.cost-accounting.progress.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <mat-slider
                            disabled
                            showTickMarks
                            [min]="0"
                            [max]="3"
                            [step]="1"><input matSliderThumb [value]="costAccountingStateProgress[element.state]" />
                        </mat-slider>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>{{ "app.page.cost-accounting.analytics.label" | translate }}</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button
                                [disabled]="costAccountingStateProgress[element.state] !== 3"
                                (click)=" $event.stopPropagation()"
                                [routerLink]="['/cost-unit-cost']"
                                [queryParams]="{costAccounting: element.id}">
                            <mat-icon>query_stats</mat-icon>
                        </button>
                    </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;" (click)="openDialog(row)"></tr>
            </table>
        </div>
        <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50]"></mat-paginator>
    </div>

</ng-container>
